<template>
  <div>
    <container-headline
      :headline="$t('global.personaldata')"
      :col="6"
    ></container-headline>

    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="col-xl-12">
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <input
                      v-model.trim="personenangaben.vorname"
                      class="form-control"
                      v-bind:class="{ 'border-danger': !passed }"
                      placeholder=" "
                      :readonly="!editable"
                    />
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.firstname")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <input
                      v-model.trim="personenangaben.name"
                      class="form-control"
                      v-bind:class="{ 'border-danger': !passed }"
                      placeholder=" "
                      :readonly="!editable"
                    />
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.surname")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <v-select
                      v-model="personenangaben.geschlecht"
                      label="bezeichnung"
                      v-bind:class="!passed ? 'border-danger' : ''"
                      :options="geschlechter"
                      :disabled="!editable"
                      :placeholder="$t('global.gender')"
                    >
                      <span slot="no-options">{{
                        $t("global.taptosearch")
                      }}</span>
                    </v-select>
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.gender")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <date-picker
                    date-format="dd.mm.yy"
                    :initial="personenangaben.geburtsdatum"
                    placeholder=" "
                    :show-icon="true"
                    :disabled="!editable"
                    @update="(val) => (personenangaben.geburtsdatum = val)"
                    :validation="dateValid"
                    :label="$t('global.dateofbirth')"
                  />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.nationalitaet"
                    label="bezeichnungMitIso"
                    :options="nationalitaeten"
                    :disabled="!editable"
                    :placeholder="$t('global.nationality')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>

                    <span slot="option" slot-scope="nationalitaet">
                      {{ nationalitaet.bezeichnungMitIso }}
                    </span>
                  </v-select>
                  <label>{{ $t("global.nationality") }}</label>
                </div>
              </div>
            </div>
            <div
              class="row"
              v-if="
                personenangaben.nationalitaet &&
                personenangaben.nationalitaet.id !== '1746DEB982E'
              "
            >
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.aufenthaltsbewilligung"
                    label="bezeichnung"
                    :options="aufenthaltsbewilligungen"
                    :disabled="!editable"
                    :placeholder="$t('global.typeofresidencepermit')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.typeofresidencepermit") }}</label>
                </div>
              </div>
              <!-- <div class="col-xl-4">
                <div class="form-group">
                  <label>
                    {{ $t("global.documentresidencepermit") }}
                  </label>
                  <div
                    class="file-upload"
                    @click="triggerFileUpload"
                    :title="selectedFile ? selectedFile : ''"
                  >
                    {{ selectedFile ? selectedFile : $t("global.selectfile") }}
                    <input
                      type="file"
                      ref="dokumentAufenthaltsbewilligung"
                      :readonly="!editable"
                      hidden
                      @change="handleFileChange"
                    />
                  </div>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group d-flex align-items-center pos-r">
                  <label>{{ $t("global.privatephone") }}</label>
                  <div class="input-wrapper d-flex align-items-center pos-r">
                    <vue-tel-input
                      class="phone-input padding-right-35px"
                      id="phone-private"
                      v-model="personenangaben.telefonP"
                      :disabled="!editable"
                      :inputOptions="inputOptions"
                      mode="international"
                    ></vue-tel-input>
                    <div
                      class="call-button pos-a top-0 right-0 bottom-0 d-flex padding-x-10px clickable hover-success"
                      @click="call(personenangaben.telefonP)"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-phone-arrow-up-right"
                        class="m-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group d-flex align-items-center pos-r">
                  <label>{{ $t("global.mobilephone") }}</label>
                  <div class="input-wrapper d-flex align-items-center pos-r">
                    <vue-tel-input
                      class="phone-input padding-right-35px"
                      id="phone-mobile"
                      v-model="personenangaben.telefonM"
                      :disabled="!editable"
                      :inputOptions="inputOptions"
                      mode="international"
                    ></vue-tel-input>
                    <div
                      class="call-button pos-a top-0 right-0 bottom-0 d-flex padding-x-10px clickable hover-success"
                      @click="call(personenangaben.telefonM)"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-phone-arrow-up-right"
                        class="m-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.korrespondenzsprache"
                    :options="unterrichtssprachen"
                    label="bezeichnung"
                    :disabled="!editable && !isAdmin"
                    :placeholder="$t('global.correspondencelanguage')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.correspondencelanguage") }}</label>
                </div>
              </div>
            </div>
            <div class="row" v-show="!bauernrolle">
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.sprachkenntnisDE"
                    label="bezeichnung"
                    :options="sprachkenntnisse"
                    :disabled="!editable"
                    :placeholder="$t('global.germanlanguageskills')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.germanlanguageskills") }}</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.sprachkenntnisFR"
                    label="bezeichnung"
                    :options="sprachkenntnisse"
                    :disabled="!editable"
                    :placeholder="$t('global.frenchlanguageskills')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.frenchlanguageskills") }}</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.sprachkenntnisIT"
                    label="bezeichnung"
                    :options="sprachkenntnisse"
                    :disabled="!editable"
                    :placeholder="$t('global.italianlanguageskills')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.italianlanguageskills") }}</label>
                </div>
              </div>
            </div>
            <div class="row" v-show="bauernrolle">
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.sprachen"
                    label="bezeichnung"
                    :options="crmSprachen"
                    :reduce="
                      (sprache) => ({
                        id: sprache.id,
                        bezeichnung: sprache.bezeichnung,
                      })
                    "
                    :disabled="!editable"
                    :placeholder="$t('global.languages')"
                    multiple
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.languages") }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.partnerrollen"
                    label="bezeichnung"
                    :options="partnerrollen"
                    :reduce="
                      (partnerrolle) => ({
                        id: partnerrolle.id,
                        bezeichnung: partnerrolle.bezeichnung,
                      })
                    "
                    :disabled="!editable"
                    :placeholder="$t('global.partnerrole')"
                    multiple
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.partnerrole") }}</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <ValidationProvider
                    :rules="checkAHV ? 'ahv' : ''"
                    immediate
                    v-slot="{ passed }"
                  >
                    <input
                      v-model.trim="personenangaben.sozialversicherungsnummer"
                      class="form-control"
                      v-bind:class="{ 'border-danger': !passed }"
                      placeholder=" "
                      :readonly="!editable"
                      :tabindex="101"
                      @blur="checkAHV ? checkAHVFormat() : null"
                    />
                    <span
                      v-if="!passed"
                      class="minusIcon"
                      v-tooltip="$t('global.ahvformaterror')"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-exclamation-triangle"
                      />
                    </span>
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.socialsecuritynumber")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <input
                    v-model.trim="personenangaben.funktion"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                  />
                  <label>{{ $t("global.function") }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <input
                    type="number"
                    v-model.trim="personenangaben.anwesenheit"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                  />
                  <label>{{ $t("global.attendance") }}</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <v-select
                    v-model="personenangaben.aktivitaetsstatus"
                    :options="aktivitaetsstati"
                    label="bezeichnung"
                    :disabled="!editable && !isAdmin"
                    :placeholder="$t('global.status')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.status") }}</label>
                </div>
              </div>
              <div class="form-check col-xl-4" style="padding-left: 36px">
                <input
                  type="checkbox"
                  v-model="weitereAngaben.istRaucher"
                  class="form-check-input"
                  :disabled="!editable"
                />
                <label>{{ $t("global.smoker") }}</label>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <input
                    v-model.trim="personenangaben.bildungseinrichtung"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                  />
                  <label>{{ $t("global.nameofeducationalinstitution") }}</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <input
                    v-model.trim="personenangaben.studienrichtung"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                  />
                  <label>{{ $t("global.fieldofstudy") }}</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <input
                    v-model.trim="personenangaben.ausbildungsbezeichnung"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                  />
                  <label>{{ $t("global.trainingtitle") }}</label>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";
import DatePicker from "@/components/Datepicker";
import { LADE_AUSWAHLWERTE_EINSTELLUNGEN } from "@/store/einstellungendashboard/actions.type";

export default {
  name: "GeschaeftspartnerPersonalangabenNewViva",
  components: {
    ContainerHeadline,
    DatePicker,
  },
  mixins: [],
  props: {
    personenangaben: {
      type: Object,
      default: function () {
        return {};
      },
    },
    weitereAngaben: {
      type: Object,
      default: function () {
        return {};
      },
    },
    checkAHV: {
      type: Boolean,
      required: false,
      default: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    dateValid: {
      type: Boolean,
      required: false,
      default: true,
    },
    bauernrolle: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isAdmin: false,
      selectedFile: null,
      selectedPartnerrollen: {},
      selectedSprachen: {},
    };
  },
  computed: {
    inputOptions() {
      return { placeholder: this.$t("global.enteraphonenumber") };
    },
    nationalitaeten: {
      get() {
        const priorisierte = [
          "Schweiz",
          "Österreich",
          "Deutschland",
          "Italien",
        ];
        const alle = this.$store.state.geschaeftspartner.nationalitaeten || [];

        return [...alle].sort((a, b) => {
          const aIndex = priorisierte.indexOf(a.name);
          const bIndex = priorisierte.indexOf(b.name);

          // Falls beide in der Prioritätenliste sind, nach deren Reihenfolge sortieren
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          // Falls nur einer in der Liste ist, der kommt zuerst
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;
          // Sonst alphabetisch nach name
          return a.name.localeCompare(b.name);
        });
      },
    },
    langs: {
      get() {
        return this.$store.state.einstellungendashboard.sprachen;
      },
    },
    partnerrollen: {
      get() {
        return this.$store.state.geschaeftspartner.partnerrollen;
      },
    },
    geschlechter: {
      get() {
        return this.$store.state.geschaeftspartner.geschlechter;
      },
    },
    aufenthaltsbewilligungen: {
      get() {
        return this.$store.state.geschaeftspartner.aufenthaltsbewilligungen;
      },
    },
    niveaus: {
      get() {
        return this.$store.state.geschaeftspartner.kompetenzstufen;
      },
    },
    unterrichtssprachen: {
      get() {
        return this.$store.state.geschaeftspartner.unterrichtssprachen;
      },
    },
    crmSprachen: {
      get() {
        return this.$store.state.crm.sprachen;
      },
    },
    sprachkenntnisse: {
      get() {
        return this.$store.state.geschaeftspartner.sprachkenntnisse;
      },
    },
    aktivitaetsstati: {
      get() {
        return this.$store.state.geschaeftspartner.aktivitaetsstati;
      }
    }
  },
  created() {},
  watch: {
    ["person.rolle"]: {
      handler: function (val) {
        if (val && this.partnerrollen.length > 0) {
          this.$emit("rolesChanged", val);
        }
      },
      immediate: true,
    },
    // selectedPartnerrollen: {
    //   handler: function (val) {
    //     this.personenangaben.partnerrollen = val.map(
    //       (partnerrolle) => partnerrolle.id
    //     );
    //   },
    // },
  },
  mounted() {},
  methods: {
    call(telefonnummer) {
      if (telefonnummer) window.location.href = `tel:${telefonnummer}`;
    },

    triggerFileUpload() {
      if (this.$refs.dokumentAufenthaltsbewilligung) {
        this.$refs.dokumentAufenthaltsbewilligung.click();
      }
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file.name;
      }
    },

    checkAHVFormat() {
      let ahvno = this.personenangaben.sozialversicherungsnummer;

      if (ahvno == "" || ahvno.includes(".")) return;

      let p1 = ahvno.substring(0, 3);
      let p2 = ahvno.substring(3, 7);
      let p3 = ahvno.substring(7, 11);
      let p4 = ahvno.substring(11, 13);

      this.personenangaben.sozialversicherungsnummer =
        p1 + "." + p2 + "." + p3 + "." + p4;
    },
  },
};
</script>

<style></style>
